import sileo from 'sileo';
import axios from 'source/lib/axios';


const ResendVerificationEmail = new sileo.Model(
    'hqzen', 'resend-business-verification'
);
const SpecialistUserProfile = new sileo.Model('hqzen', 'specialist-user-profile');
const HQZenSpecialists = new sileo.Model('hqzen', 'hqzen-specialists');
const Talent = new sileo.Model('hqzen', 'talent');

const state = {};

const getters = {};

const mutations = {};

const actions = {
    resendEmailVerification(context, data) {
        const formData = new FormData();
        formData.append('workforce_id', data);
        return ResendVerificationEmail.objects.create(formData);
    },

    fetchSpecialistUserProfile() {
        return SpecialistUserProfile.objects.filter();
    },

    fetchHQZenSpecialists() {
        return HQZenSpecialists.objects.filter();
    },

    fetchTalents(context, payload) {
        return Talent.objects.filter(payload);
    },

    fetchCandidateProfile(_, applicationId) {
        return axios.get('hqzen/candidate-profile/', {
            params: {
                application_id: applicationId,
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
